import React from 'react';
import {connect} from "react-redux";
import classNames from 'classnames';
import $ from 'jquery';

import {
  toggleDesktopNavigation,
  setActiveNavigationNames,
  setModuleContextMenuType,
  setActiveNavigationFilter, setActiveNavigationFilterStepIndex, setNavigationViewType, setNavigationLoading
} from "../../../actions/navigationFunctions";
import {setDefaultSelectionGroup, changeActivePartRelatedItemIndex} from "../../../actions/actionFunctions";
import DesktopNavigationCommon from "../../visComponents/navigation/desktopNavigationCommon";
import Z from "../core/zIndex";
import {getCurrentLayout} from "../../appLayout";

import LockedView from "../../common/lockedView";
import {ContentType} from "../../visComponents/constants";
import ContextMenuSimple from "./contextMenuSimple";
import CabinetContextMenu from "./cabinetContextMenu";
import MobileMenuSelect from "../../visComponents/navigation/mobile/mobileMenuSelect";
import {CABINET_WIZARD_BUTTONS, COUNTERTOP_WIZARD_BUTTONS} from "../core/constants";
import {setVisualizerTutorialStep, showVisualizerTutorial} from "../../../actions/tutorialFunctions";

class DesktopNavigation extends DesktopNavigationCommon {

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.activeNavigationFilter !== this.props.activeNavigationFilter
      && COUNTERTOP_WIZARD_BUTTONS.some(btn => btn.buttonId === nextProps.activeNavigationFilter)) {
      if (this.state.parentNavigationItem && this.state.parentNavigationItem.part.partName === "Countertop") {
        const subParts = this.state.parentNavigationItem.part.subParts();
        let subPart = null;
        switch (nextProps.activeNavigationFilter) {
          case COUNTERTOP_WIZARD_BUTTONS[0].buttonId:
          case COUNTERTOP_WIZARD_BUTTONS[1].buttonId:
          case COUNTERTOP_WIZARD_BUTTONS[2].buttonId:
            subPart = subParts.find(sPart => sPart.part.partId === "countertop");
            break;
          case COUNTERTOP_WIZARD_BUTTONS[3].buttonId:
            subPart = subParts.find(sPart => sPart.part.partId === "edge_profile");
            break;
          case COUNTERTOP_WIZARD_BUTTONS[4].buttonId:
            if (!this.state.childNavigationItem
              || (this.state.childNavigationItem && this.state.childNavigationItem.part.partId !== "backsplash")) {
              this.triggerOpenNavigationMenu("Backsplash", "Walls", nextProps.activeNavigationFilter);
            }
            break;
        }
        if (subPart && (!this.state.childNavigationItem
          || (this.state.childNavigationItem && this.state.childNavigationItem.part.partId !== subPart.part.partId))) {
          this.handleSubPartClick(subPart, nextProps.activeNavigationFilter)
        }
      } else if (this.state.parentNavigationItem && this.state.parentNavigationItem.part.partName === "Walls") {
        switch (nextProps.activeNavigationFilter) {
          case COUNTERTOP_WIZARD_BUTTONS[0].buttonId:
          case COUNTERTOP_WIZARD_BUTTONS[1].buttonId:
          case COUNTERTOP_WIZARD_BUTTONS[2].buttonId:
            if (!this.state.childNavigationItem
              || (this.state.childNavigationItem && this.state.childNavigationItem.part.partId !== "countertop")) {
              this.triggerOpenNavigationMenu("Countertop", "Countertop", nextProps.activeNavigationFilter);
            }
            break;
          case COUNTERTOP_WIZARD_BUTTONS[3].buttonId:
            if (!this.state.childNavigationItem
              || (this.state.childNavigationItem && this.state.childNavigationItem.part.partId !== "edge_profile")) {
              this.triggerOpenNavigationMenu("Edge Profile", "Countertop", nextProps.activeNavigationFilter);
            }
            break;
        }
      } else if (this.state.parentNavigationItem && this.state.parentNavigationItem.part.partName === "CenterIsland") {
        const subParts = this.state.parentNavigationItem.part.subParts();
        let subPart = null;
        switch (nextProps.activeNavigationFilter) {
          case COUNTERTOP_WIZARD_BUTTONS[0].buttonId:
          case COUNTERTOP_WIZARD_BUTTONS[1].buttonId:
          case COUNTERTOP_WIZARD_BUTTONS[2].buttonId:
            subPart = subParts.find(sPart => sPart.part.partId === "center_island_countertop");
            break;
          case COUNTERTOP_WIZARD_BUTTONS[3].buttonId:
            subPart = subParts.find(sPart => sPart.part.partId === "center_island_edge");
            break;
        }
        if (subPart && (!this.state.childNavigationItem
          || (this.state.childNavigationItem && this.state.childNavigationItem.part.partId !== subPart.part.partId))) {
          this.handleSubPartClick(subPart, nextProps.activeNavigationFilter)
        }
      }
    }
    this._UNSAFE_componentWillReceiveProps(nextProps)
  }

  bindCanvasClick = (event) => {
    const layout = getCurrentLayout();
    // const canvas = document.getElementById(this.props.canvasId);
    this.props.setHoveredLayer(event);

    if (document.hoveredLayer) {

      const layoutType = layout.getCurrentLayoutName();

      const hoveredZone = Z.getMenuByHoveredLayer(layoutType, document.hoveredLayer);

      // console.log('hoveredZone', hoveredZone);

      if (hoveredZone) {
        if (hoveredZone.contextMenuPartId && !this.state.showNavigation) {
          if (this.state.contextMenuOpen) {
            this.setState({
              contextMenuOpen: false,
              hoveredLayer: {}
            });
          } else {
            this.openContextMenu(hoveredZone, event);
          }
          return false;
        } else if (this.state.contentType === 0) {
          this.setState({
            showNavigation: true,
            contentType: ContentType.Design,
            contextMenuOpen: false,
            hoveredLayer: {}
          }, () => {
            this.setNewActiveFeature();
            this.menuOpened();
            setTimeout(() => {
              $(document).on('click', this.handleWrapperBlur);
            }, 0)
          });
        }

        hoveredZone.child
          ? this.triggerOpenNavigationMenu(hoveredZone.child, hoveredZone.parent)
          : this.triggerOpenNavigationMenu(hoveredZone)

      }

    }

  };

  openContextMenu = (contextMenuOpen, event) => {
    let contextMenuButtons = [];
    if (contextMenuOpen.contextMenuPartId === "top_cabinet") {
      // const hoveredParent = this.props.designNavigationItems.find(navItem => {
      //   return navItem.text === "Cabinet"
      // });
      // if (hoveredParent) {
      //
      // }
      contextMenuButtons = [1, 2, 3, 4, 5]
    }
    // const receiveBackSplashes = () => {
    //   const layout = getCurrentLayout();
    //   const wallsParent = layout.parts["Walls"];
    //   const backsplashSubPart = wallsParent.subParts().find(subPart => subPart.part.partId === "backsplash");
    //   this.checkIfAllFeaturesReceived(backsplashSubPart);
    // };
    switch (contextMenuOpen.contextMenuPartId) {
      case "countertop_group_custom":
        contextMenuOpen = "Countertop";
        break;
      case "right_wall_custom":
        contextMenuOpen = "right_wall_custom";
        break;
      case "left_wall_custom":
        contextMenuOpen = "left_wall_custom";
        break;
      case "backsplash_custom_left": {
        // receiveBackSplashes();
        contextMenuOpen = "backsplash_custom_left";
        break;
      }
      case "backsplash_custom_right": {
        // receiveBackSplashes();
        contextMenuOpen = "backsplash_custom_right";
        break;
      }
      case "backsplash_custom": {
        // receiveBackSplashes();
        contextMenuOpen = "backsplash_custom";
        break;
      }
      case "center_island_custom":
        contextMenuOpen = "Center Island";
        break;
      default:
        break;
    }
    const isMobile = $(window).width() < 991;

    let left = isMobile ? '50%' : event.clientX - 50;
    let top = isMobile ? '50%' : event.clientY - 50;
    let right = 'auto';

    const maxAllowedWidth = contextMenuButtons.length > 2 ? 300 : 210;

    let maxAllowedHeight = 110;
    if (contextMenuButtons.length > 6) {
      maxAllowedHeight = 330;
    } else if (contextMenuButtons.length > 3) {
      maxAllowedHeight = 220;
    }
    if (!isMobile && (left > window.innerWidth - maxAllowedWidth)) {
      left = 'auto';
      right = 0
    }
    if (!isMobile && (top > window.innerHeight - maxAllowedHeight)) {
      let negativeMargin = 50;
      if (contextMenuButtons.length > 6) {
        negativeMargin = 250;
      } else if (contextMenuButtons.length > 3) {
        negativeMargin = 150;
      }
      top = top - negativeMargin;
    }
    this.setState({
      contextMenuOpen,
      hoveredLayer: document.hoveredLayer,
      contextMenuPosition: {
        left,
        right,
        top,
      }
    });
  };

  handleNavigationItemClick = (item, ignoreLocked = false) => {
    this.navigationItemClickCommon(item);

    this.itemClick(item, ignoreLocked);

    const updateSideBarIds = ["center_island_cabinet", "top_cabinet"];
    if (updateSideBarIds.includes(item.part.partId)) {
      this.updateSideBar();
    }

    if (this.state.parentNavigationItem) {  // update canvas only if it is child
      this.props.refreshCB();
    }
  };

  render() {
    const layout = getCurrentLayout();
    // const fabricatorSettings = this.props.fabricatorSettings;
    const activePart = this.state.parentNavigationItem ? this.state.parentNavigationItem.part : null;
    const activeSubPart = this.state.childNavigationItem ? this.state.childNavigationItem.part : null;
    // const activeNavPart = activeSubPart || activePart;
    const parentItems = layout.designNavigationItems();  // parent list without filters

    const useWizard = false, wizardGroups = [];

    let showNavigationFiltersSteps = activeSubPart
      && this.props.activeNavigationFilter !== CABINET_WIZARD_BUTTONS[0].buttonId
      && this.props.activeNavigationFilter !== "inlay_type"
      && activeSubPart.canUseNavigationFilter && activeSubPart.canUseNavigationFilter() ;

    if (activeSubPart && activeSubPart.canUseNavigationFilterSteps
      && activeSubPart.canUseNavigationFilterSteps()) {
      showNavigationFiltersSteps = !this.props.countertopNavigationFilterCompleted;
    }

    const showLockedView = this.currentActiveItemIsLocked(useWizard);

    const useFilters = false;
    const availableNavButtons = [ContentType.Design, ContentType.Layout, ContentType.DisplayRoom];

    return (
      <div className={classNames('nav-overlay', {'nav-overlay--fullwidth': this.state.showNavigation})}>
        <div
          className={classNames('nav', {'nav--opened': this.state.showNavigation}, 'nav--' + this.state.contentType)}>
          <div className="nav-wrapper" ref={(node) => this.navWrapper = node}>
            <div className="nav-wrapper__content">
              <div className="nav-wrapper__content-body">
                {this.content(useWizard, wizardGroups, useFilters, activePart, activeSubPart)}
              </div>
              <button className="nav-wrapper__content-close" onClick={this.closeNavigation}/>
            </div>
            {this.navigationMenuButtons(availableNavButtons)}
            {showNavigationFiltersSteps ? null : (
              <div className="nav-wrapper__select" onClickCapture={this.handleMobileSelectClick}>
                <MobileMenuSelect parentItems={parentItems}
                                  desktop={true}
                                  opened={this.state.showNavigation}
                                  activePart={activePart}
                                  activeSubPart={activeSubPart}
                                  onSubPartClick={this.handleSubPartClick}
                                  onParentItemClick={this.handleParentItemClick}/>
              </div>
            )}
            {/*<div className="nav-wrapper__search">*/}
            {/*<div className="search">*/}
            {/*<input className={"search-input" + (this.state.searchText ? " search-input--no-icon" : "")}*/}
            {/*value={this.state.searchText}*/}
            {/*onChange={this.handleSearchInputChange} placeholder="search"/>*/}
            {/*</div>*/}
            {/*</div>*/}
          </div>
          {this.state.contextMenuOpen && this.state.contextMenuOpen.module
            ? <CabinetContextMenu updateCanvas={this.props.refreshCB}
                                  contextMenuOpen={this.state.contextMenuOpen}
                                  hoveredLayer={this.state.hoveredLayer}
                                  contextMenuPosition={this.state.contextMenuPosition}
                                  handleContextMenuClick={this.handleContextMenuClick}
                                  closeContextMenu={this.closeContextMenu}
            />
            : null}
          {this.state.contextMenuOpen && !this.state.contextMenuOpen.module
            ? <ContextMenuSimple contextMenuOpen={this.state.contextMenuOpen}
                                 hoveredLayer={this.state.hoveredLayer}
                                 contextMenuPosition={this.state.contextMenuPosition}
                                 handleContextMenuClick={this.handleContextMenuClick}
                                 closeContextMenu={this.closeContextMenu}
                                 renderGreenLayerByZindex={this.props.renderGreenLayerByZindex}
            />
            : null}
        </div>
        {showLockedView
          ? <LockedView setActiveFeature={this.resetActiveFeature} handleUserLoginClick={this.handleUserLoginClick}/>
          : null}
      </div>
    )
  }

}

const mapStateToProps = (store) => ({
  filtersVisible: store.filterState.showFilters,
  filterGroups: store.filterState.filterGroups,
  bvPresets: store.bathroomVisualizerState.bvPresets,
  userIsLoggedIn: store.userState.userIsLoggedIn,
  isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
  activeNavigationFilter: store.navigationState.activeNavigationFilter,
  countertopNavigationFilterCompleted: store.navigationState.countertopNavigationFilterCompleted,
  visualizerTutorialStep: store.tutorialState.visualizerTutorialStep,
  visualizerTutorialIsOpened: store.tutorialState.visualizerTutorialIsOpened,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
});

const mapDispatchToProps = {
  setNavigationViewType,
  toggleDesktopNavigation,
  setActiveNavigationNames,
  setModuleContextMenuType,
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setDefaultSelectionGroup,
  changeActivePartRelatedItemIndex,
  setVisualizerTutorialStep,
  showVisualizerTutorial,
  setNavigationLoading
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(DesktopNavigation);
